import {
  ButtonBase,
  ButtonBaseProps,
  ButtonBaseTypeMap,
  CircularProgress,
} from '@material-ui/core'
import cls from 'classnames'
import React from 'react'

import { useStyles } from './styles'

interface ButtonProps {
  loading?: boolean
  disabled?: boolean
  type?: 'reset' | 'submit' | 'button'
  outlined?: boolean
  labelOnly?: boolean
  redBorder?: boolean
  filled?: boolean
  error?: boolean
}

const Button = <
  C extends React.ElementType = ButtonBaseTypeMap['defaultComponent'],
>(
  {
    children,
    type = 'button',
    className,
    disabled,
    loading,
    outlined,
    labelOnly,
    redBorder,
    filled,
    error,
    ...args
  }: ButtonBaseProps<C, { component?: C } & ButtonProps>,
  ref?: React.ForwardedRef<React.ComponentProps<C>>,
) => {
  const classes = useStyles()

  return (
    <ButtonBase
      ref={ref}
      className={cls(
        classes.main,
        {
          [classes.default]:
            !outlined && !labelOnly && !redBorder && !filled && !error,
          [classes.outlined]: outlined,
          [classes.labelOnly]: labelOnly,
          [classes.redBorder]: redBorder,
          [classes.filled]: filled,
          [classes.error]: error,
        },
        className,
      )}
      disabled={disabled || loading}
      type={type}
      {...args}
    >
      {loading ? (
        <CircularProgress color={'inherit'} size={'1.8rem'} thickness={5} />
      ) : (
        children
      )}
    </ButtonBase>
  )
}

export default React.forwardRef(Button) as typeof Button
